
import "../DropdownBase/DropdownBase.st.css.js";
import "../Popover/Popover.st.css.js";
import "../Foundation/stylable/colors.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_181_0_InputWithOptions";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_181_0_InputWithOptions__root","nativeSelectWrapper":"wds_1_181_0_InputWithOptions__nativeSelectWrapper","nativeSelect":"wds_1_181_0_InputWithOptions__nativeSelect"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"focusBoxShadow":"var(--wds-shadow-focus-standard, 0 0 0 3px var(--wsr-color-F00, #A6D0FF))"}; 
export var vars = {"wds-border-radius-surface-overlay":"--wds-border-radius-surface-overlay","wds-dropdown-list-paddings":"--wds-dropdown-list-paddings","wds-shadow-focus-standard":"--wds-shadow-focus-standard","wds-color-border-standard-secondary-active":"--wds-color-border-standard-secondary-active","wds-color-fill-surface-overlay":"--wds-color-fill-surface-overlay"}; 




